import { Drawer, Accordion, Text, ScrollArea } from "@mantine/core";
function HelpDrawer({ opened, setOpened }) {
	return (
		<>
			<Drawer
				opened={opened}
				onClose={() => setOpened(false)}
				title="Help"
				padding="xl"
				size="xl"
				position="right"
				lockScroll={true}
				styles={{
					drawer: { backgroundColor: "#040f1f" },
					title: { fontSize: "25px", color: "white" },
					root: { overflowY: "auto" },
				}}
			>
				<ScrollArea h={500}>
					<Accordion
						variant="contained"
						styles={{
							item: {
								color: "white",
								"&[data-active]": {
									backgroundColor: "#14B8E1",
								},
							},
							control: {
								color: "white",
								"&:hover": {
									backgroundColor: "#14B8E1",
								},
							},
						}}
					>
						<Accordion.Item value="Get Started">
							<Accordion.Control>Get Started</Accordion.Control>
							<Accordion.Panel>
								<Text fw={500}>
									Which browsers support iVisit?
								</Text>
								<ul>
									<li>
										iVisit is supported on all the latest
										browsers such as Chrome, Firefox,
										Safari, Edge
									</li>
								</ul>
								<Text fw={500}>
									Where can I find 360° images?
								</Text>
								<ul>
									<li>
										For stock images, you may search for{" "}
										<span>
											equirectangular images on Flickr
										</span>
									</li>
									<li>
										For custom 360° photos, you may{" "}
										<span>contact us here</span>
									</li>
								</ul>
								<Text fw={500}>
									How do I look around in the Scene?
								</Text>
								<ul>
									<li>
										Simply place your mouse cursor over the
										scene, &amp; drag to rotate your view to
										look around in the scene.
									</li>
								</ul>
							</Accordion.Panel>
						</Accordion.Item>

						<Accordion.Item value="Scenes">
							<Accordion.Control>Scenes</Accordion.Control>
							<Accordion.Panel>
								<Text fw={500}>Adding a Scene</Text>
								<ul>
									<li>
										To add a Scene, click on the ‘Add
										Scenes’ button on the bottom left corner
										of the editor
									</li>
									<li>
										Upload or select a 360° image from the
										media gallery and press the ‘Done’
										button
									</li>
								</ul>
								<Text fw={500}>
									Updating a Scene’s background
								</Text>
								<ul>
									<li>
										To edit a Scene, click on the ‘Edit’
										button of the corresponding Scene at the
										bottom of the editor
									</li>
								</ul>
								<Text fw={500}>Deleting a Scene</Text>
								<ul>
									<li>
										To delete a Scene, click on the ‘Delete’
										button of the corresponding Scene at the
										bottom of the editor
									</li>
								</ul>
								<Text fw={500}>Renaming a Scenes</Text>
								<ul>
									<li>
										To rename a Scene, click on the name of
										the corresponding Scene at the bottom of
										the editor, and enter a name of your
										choice
									</li>
								</ul>
								<Text fw={500}>Rearranging your Scenes</Text>
								<ul>
									<li>
										To rearrange your Scenes, drag the Scene
										thumbnails to the order of your choice
										at the bottom of the editor
									</li>
									<li>
										The leftmost Scene will be first Scene
										that visitors will enter when they visit
										your tour
									</li>
								</ul>
								<Text fw={500}>
									Setting a Scene’s starting view
								</Text>
								<ul>
									<li>
										The starting view determines the angle
										of the Scene that viewers will see when
										they first enter the Scene
									</li>
									<li>
										To set a Scene’s starting view, drag the
										Scene’s view to your desired spot, and
										click on the ‘Set Initial Camera Target’
										button at the bottom of the editor.
									</li>
								</ul>
							</Accordion.Panel>
						</Accordion.Item>

						<Accordion.Item value="Markers">
							<Accordion.Control>Markers</Accordion.Control>
							<Accordion.Panel>
								<Text>
									Markers are interactive points that you can
									place around the scene.
								</Text>
								<Text fw={500}>Adding a Marker</Text>
								<ul>
									<li>
										To add a Marker, click on the marker
										button at bottom of the editor.
									</li>
								</ul>
								<Text fw={500}>Deleting a Marker</Text>
								<ul>
									<li>
										To delete a Marker, click on the Marker
										in the Scene, then click on the ‘Delete’
										button
									</li>
								</ul>
								<Text fw={500}>Moving a Marker</Text>
								<ul>
									<li>
										To move a Marker, click on the Marker in
										the Scene, then click on the Move tool{" "}
									</li>
									<li>
										While the Move tool is active, click and
										drag on the Marker to move it around
									</li>
								</ul>
							</Accordion.Panel>
						</Accordion.Item>
						<Accordion.Item value="Navigation">
							<Accordion.Control>Navigation</Accordion.Control>
							<Accordion.Panel>
								<Text>
									Navigation Markers allow viewers to navigate
									to the scene of your choice.
								</Text>
								<Text fw={500}>Setting a target Scene</Text>
								<ul>
									<li>
										To set a target Scene to navigate to,
										click on the target Navigation marker,
										then select the Scene of your choice
										from the dropdown menu
									</li>
								</ul>
							</Accordion.Panel>
						</Accordion.Item>
						<Accordion.Item value="Image">
							<Accordion.Control>Image</Accordion.Control>
							<Accordion.Panel>
								<ul>
									<li>
										Image Markers allows you to place images
										inside the Scene
									</li>
									<li>
										Viewers may click on Image Markers to
										view the image in a pop-up modal
									</li>
								</ul>
							</Accordion.Panel>
						</Accordion.Item>
						<Accordion.Item value="Video">
							<Accordion.Control>Video</Accordion.Control>
							<Accordion.Panel>
								<ul>
									<li>
										Video Markers allows you to place video
										files inside the Scene
									</li>
									<li>
										Viewers may click on Video Markers to
										view the video in a pop-up modal
									</li>
								</ul>
							</Accordion.Panel>
						</Accordion.Item>
						<Accordion.Item value="Create Tours">
							<Accordion.Control>Create Tours</Accordion.Control>
							<Accordion.Panel>
								<Text fw={500}>
									Can I make my Tour private?
								</Text>
								<p>
									Yes, you can, there are 2 level of Tour
									privilege that you can config including
									(public, private) and you can even determine
									whether to list your Tour on portfolio or
									not.
								</p>
								<Text fw={500}>
									How do I connect 2 or more scenes?
								</Text>
								<p>
									Navigation Marker or hotspot is used to
									connect scenes together.
								</p>
							</Accordion.Panel>
						</Accordion.Item>
						<Accordion.Item value="Publish Tours">
							<Accordion.Control>Publish Tours</Accordion.Control>
							<Accordion.Panel>
								<Text fw={500}>
									How to embed iVisit project to a WordPress
									website?
								</Text>
								<p>
									Go to your project editor and Click on the
									share button, copy the Embedded Code.
								</p>
								<p>
									Go to your WordPress website post/page,
									change Editor to Text mode and paste the
									copied code above
								</p>
								<Text fw={500}>
									How can I view my tour on a mobile?
								</Text>
								<p>
									Our tours are meant to be viewed online. To
									view your tour on a mobile, all you have to
									do is embed your tour on a website, and
									access that website from your mobile. You
									can also access the direct link to your tour
									from a mobile, as soon as you have hosted it
									on your web server.
								</p>
								<Text fw={500}>
									How can I publish a virtual tour on the
									internet?
								</Text>
								<p>
									Go to the settings change you tour privilege
									from private to public. It will be published
									on the internet.
								</p>
								<Text fw={500}>FOR DESKTOP</Text>
								<ul>
									<li>
										Google Chrome browser (Windows, Mac,
										Linux): Google Chrome version 22 or
										higher is needed.
									</li>
									<li>
										Mozilla Firefox browser (Windows, Mac,
										Linux): Mozilla Firefox version 18 or
										higher is needed.
									</li>
									<li>
										Opera browser (Windows, Mac, Linux):
										Opera version 15 or higher is needed.
									</li>
									<li>
										Safari browser (Mac): Safari version 8
										or higher is recommended.
									</li>
									<li>
										Microsoft Internet Explorer browser
										(Windows 7, Windows 8, Windows 10,
										Windows RT): IE 10 or higher is needed.
									</li>
									<li>
										Microsoft Edge browser (Windows 10):
										Edge 12 or higher is needed.
									</li>
								</ul>
								<Text fw={500}>
									FOR MOBILE &amp; TABLET DEVICES
								</Text>
								<ul>
									<li>
										iOS Safari browser: Safari version 8 or
										higher is recommended.
									</li>
									<li>
										iOS Chrome browser: Google Chrome
										version 25 or higher is needed.
									</li>
									<li>
										iOS Firefox browser: Mozilla Firefox
										version 21 or higher is needed.
									</li>
									<li>
										Android Chrome browser: Google Chrome
										version 25 or higher is needed.
									</li>
									<li>
										Android Firefox browser: Mozilla Firefox
										version 21 or higher is needed.
									</li>
									<li>
										Android Stock (WebView-based) browser:
										Android 4.0 or higher is needed.
									</li>
									<li>
										Android Opera (Webkit-based) browser:
										Opera version 18 or higher is needed.
									</li>
									<li>
										Windows Phone 8 Internet Explorer
										browser: IE 11 or higher is needed.
									</li>
								</ul>
							</Accordion.Panel>
						</Accordion.Item>
					</Accordion>
				</ScrollArea>
			</Drawer>
		</>
	);
}

export default HelpDrawer;
